import { Form, useFormikContext } from "formik";
import { ComponentProps, FC, FormEvent } from "react";
import styled from "styled-components";

export const DrawerForm = styled(Form)`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
`;

export type SubmitAction = "save" | "next";

export interface CreateContactStepForm<T> {
	initialValues: T;
	onSubmit: (values: T) => void | Promise<void>;
}

export const DrawerFormWithSubmitter: FC<ComponentProps<"form">> = ({ onSubmit, ...props }) => {
	const formik = useFormikContext();
	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		const submitter = (e.nativeEvent as SubmitEvent).submitter;
		if (submitter && submitter instanceof HTMLButtonElement && submitter.name && submitter.value) {
			void formik.setFieldValue(submitter.name, submitter.value, false);
		}
		onSubmit?.(e as any);
		formik.handleSubmit(e);
	};

	return <DrawerForm {...props} onSubmit={handleSubmit} />;
};

export const FormActions = styled.div`
	justify-content: end;
	display: flex;
	gap: ${({ theme }) => theme.spacing(2)};
`;
